/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import '../../styles/home.scss';

import Hero from './Hero';
import WhoWeAre from './WhoWeAre';
import WhatWeDo from './WhatWeDo';
import NumberHeighlights from './NumberHighlights';
import WhyJoinUs from './WhyJoinUs';
import Leadership from './Leadership';
import VibrantWorkplace from './VibrantWorkplace';
import VoiceOfEmployees from './VoiceOfEmployees';
import JoinUs from './JoinUs';

export default function Home(){


    var typedTextSpan = document.querySelector(".typed-text");
    var cursorSpan = document.querySelector(".cursor");

    const textArray = ["Open Banking"];
    const typingDelay = 200;
    const erasingDelay = 100;
    const newTextDelay = 1000; // Delay between current and next text
    let textArrayIndex = 0;
    let charIndex = 0;

    function type() {
        if (charIndex < textArray[textArrayIndex].length) {
            if(cursorSpan && !cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            if(typedTextSpan) typedTextSpan.textContent += textArray[textArrayIndex].charAt(charIndex);
            charIndex++;
            setTimeout(type, typingDelay);
        } 
        else {
            if(cursorSpan) cursorSpan.classList.remove("typing");
            setTimeout(erase, newTextDelay);
        }
    }
      
    function erase() {
        if (charIndex > 0) {
            if(cursorSpan && !cursorSpan.classList.contains("typing")) cursorSpan.classList.add("typing");
            if(typedTextSpan) typedTextSpan.textContent = textArray[textArrayIndex].substring(0, charIndex-1);
            charIndex--;
            setTimeout(erase, erasingDelay);
        } 
        else {
            if(cursorSpan) cursorSpan.classList.remove("typing");
            textArrayIndex++;
            if(textArrayIndex>=textArray.length) textArrayIndex=0;
            setTimeout(type, typingDelay + 1100);
        }
    }

    useEffect(()=>{
        typedTextSpan = document.querySelector(".typed-text");
        cursorSpan = document.querySelector(".cursor");

        if(textArray.length) setTimeout(type, newTextDelay + 250);        
    },[]);

    return (
        <>
            <Hero />
            <WhoWeAre />
            <WhatWeDo/>
            <NumberHeighlights />
            <WhyJoinUs />
            <Leadership />
            <VibrantWorkplace />
            <VoiceOfEmployees />
            <JoinUs/>
        </>
      )
}